const colors = {
  primary: "#0066DA",
  error: "#F44336",
  success: "#4CAF50",
  warning: "#FD9900",
  blueOcean: "#001833",
  textGrey: "#9B9B9B",
  bg: "#F5FAFF",
  white: "#F5FAFF",
  grey: "#E0E0E0",
  greyLight: "#F2F3F6",
  greenMile: "#4CAF50",
};

export default colors;
